import { render, staticRenderFns } from "./appDownload.vue?vue&type=template&id=3a7a2038&scoped=true"
import script from "./appDownload.vue?vue&type=script&lang=js"
export * from "./appDownload.vue?vue&type=script&lang=js"
import style0 from "./appDownload.vue?vue&type=style&index=0&id=3a7a2038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a2038",
  null
  
)

export default component.exports